import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTraderProvider } from "../../providers/TraderProvider";
const CreditToBePaid = () => {
	const { creditToBePaid } = useTraderProvider();
	const { t } = useTranslation();

	return (
		<>
			<Box
				flex={1}
				minWidth="200px"
				maxWidth="376px"
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					flexDirection: "column",
					padding: "16px",
					borderRadius: "8px",
					margin: "8px",
				}}
				className="trader-credits-to-be-paid"
			>
				<Typography variant="body1" fontSize="24px">
					{t("trader.payable")}
				</Typography>
				<Typography variant="body1" fontSize="40px" fontWeight="bold">
					{creditToBePaid.toFixed(2)}€
				</Typography>
			</Box>
		</>
	);
};

export default CreditToBePaid;
